export default __webpack_public_path__ + "static/media/white-close-button.2518c011.png";